import queryString from 'query-string';

/** Extracts the file name from a S3 bucket URL */
export const extractFileNameFromUrl = (url: string): string | undefined => {
  const queryParams = queryString.parse(url.split('?')[1]);
  const fileName = queryParams['response-content-disposition']
    ?.toString()
    .match(/".*?"/)?.[0]
    .replace(/"/g, '');

  return fileName;
};
